import React from "react";

const PhoneFeatureGroup = ({
  image,
  size,
  topFeature,
  bottomFeature,
  moveBottomFeatureTopOnMobile = false,
}) => {
  return (
    <div className="flex flex-col items-center">
      {/* TOP PILL */}
      {topFeature && (
        <div className="mb-6 flex items-center gap-2 rounded-full border border-gray-200 bg-gradient-to-b from-[#F2F6FA] to-[#DFECFF] px-4 py-3 shadow-sm">
          {typeof topFeature.icon === "string" ? (
            <img
              src={topFeature.icon}
              alt=""
              className="h-4 w-4 object-contain"
            />
          ) : (
            <topFeature.icon size={16} className="text-primary" />
          )}

          <span className="text-primary text-sm">{topFeature.text}</span>
        </div>
      )}

      {/* BOTTOM PILL ABOVE IMAGE ON MOBILE */}
      {bottomFeature && moveBottomFeatureTopOnMobile && (
        <div className="mb-6 flex items-center gap-2 rounded-full border border-gray-200 bg-gradient-to-b from-[#F2F6FA] to-[#DFECFF] px-4 py-3 shadow-sm md:hidden">
          {typeof bottomFeature.icon === "string" ? (
            <img
              src={bottomFeature.icon}
              alt=""
              className="h-4 w-4 object-contain"
            />
          ) : (
            <bottomFeature.icon size={16} className="text-primary" />
          )}

          <span className="text-primary text-sm">{bottomFeature.text}</span>
        </div>
      )}

      {/* PHONE */}
      <img
        src={image}
        alt="mobile"
        className={`object-contain drop-shadow-xl transition-all duration-300 ${
          size === "large" ? "w-[250px] md:w-[270px]" : "w-[220px] md:w-[230px]"
        } `}
      />

      {/* NORMAL BOTTOM PILL */}
      {bottomFeature && (
        <div
          className={`mt-6 items-center gap-2 rounded-full border border-gray-200 bg-gradient-to-b from-[#F2F6FA] to-[#DFECFF] px-4 py-3 shadow-sm ${
            moveBottomFeatureTopOnMobile ? "hidden md:flex" : "flex"
          } `}
        >
          {typeof bottomFeature.icon === "string" ? (
            <img
              src={bottomFeature.icon}
              alt=""
              className="h-4 w-4 object-contain"
            />
          ) : (
            <bottomFeature.icon size={16} className="text-primary" />
          )}

          <span className="text-primary text-sm">{bottomFeature.text}</span>
        </div>
      )}
    </div>
  );
};

export default PhoneFeatureGroup;
